import { isBefore } from 'date-fns'

function lastDayOfMonth(ds) {
	let day = ds.split('/')[1],
		month = ds.split('/')[0],
		year = ds.split('/')[2]

	let lastDay = new Date(year, month, 0).getDate()

	return lastDay === parseInt(day)
}

function verifyDates(startDate, endDate, errorMessage, navigateForward) {
	let startDay = startDate.split('/')[1],
		startMonth = startDate.split('/')[0],
		startYear = startDate.split('/')[2]
	let endDay = endDate.split('/')[1],
		endMonth = endDate.split('/')[0],
		endYear = endDate.split('/')[2]

	if (startDate === '') {
		errorMessage('Lease Start Date is required')
	} else if (endDate === '') {
		errorMessage('Lease End Date is required')
	} else if (
		isBefore(
			new Date(endYear, endDay, endMonth),
			new Date(startYear, startDay, startMonth)
		)
	) {
		errorMessage('Lease Start Date must be before the Lease End Date.')
	} else if (startDate.slice(3, 5) !== '01') {
		if (lastDayOfMonth(startDate)) {
			navigateForward(startDate, endDate)
		} else {
			errorMessage('Please Select the First Day or Last Day of the Month')
		}
	} else {
		navigateForward(startDate, endDate)
	}
}

function lengthInMonths(dateOne, dateTwo) {
	const date1 = new Date(dateOne)
	const date2 = new Date(dateTwo)

	var diff = Math.floor(date1.getTime() - date2.getTime())
	var day = 1000 * 60 * 60 * 24

	var days = Math.floor(diff / day)
	var months = Math.floor(days / 31)

	let message = ''

	if (Math.abs(months) === 1) {
		message = Math.abs(months) + ' month'
	} else {
		months -= 1
		message = Math.abs(months) + ' months'
	}

	return message
}

export { lastDayOfMonth, verifyDates, lengthInMonths }
